import React, { useEffect, useRef } from 'react';

const MathText = ({ text }) => {
  const nodeRef = useRef(null);

  useEffect(() => {
    if (window.MathJax && nodeRef.current) {
      window.MathJax.typesetPromise([nodeRef.current]).catch((err) => console.log(err));
    }
  }, [text]);

  return <span ref={nodeRef}>{text}</span>;
};

export default MathText;